var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"app"}},[_c('router-view',{staticClass:"flex-fill"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }